export const errors = {
  collection: {
    update: 'Une erreur est survenu durant la modification la pièce. Veuillez réessayer.',
    create: 'Une erreur est survenu durant l\'ajout de la pièce à la collection. Veuillez réessayer.',
    get: 'Une erreur est survenu durant la récupération de la collection. Veuillez réessayer.',
    remove: 'Une erreur est survenu durant la suppression de la pièce. Veuillez réessayer.',
  },
  search: {
    request: 'Une erreur est survenue pendant la rechercher, veuillez réessayer.'
  }
};

export const success = {
  auth: {
    signin: 'Vous êtes maintenat connecté.',
    signout: 'Vous êtes maintenat déconnecté.',
  },
};
